"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._crmFeatureIds = exports._cmsEnterpriseFeatureIds = exports._cmsProfessionalFeatureIds = exports._cmsFeatureIds = exports._serviceEnterpriseFeatureIds = exports._serviceProfessionalFeatureIds = exports._serviceStarterFeatureIds = exports._serviceFreeFeatureIds = exports._salesEnterpriseFeatureIds = exports._salesProfessionalFeatureIds = exports._salesStarterFeatureIds = exports._salesFreeFeatureIds = exports._marketingEnterpriseFeatureIds = exports._marketingProfessionalFeatureIds = exports._marketingStarterFeatureIds = exports._marketingFreeFeatureIds = void 0;

var _extends12 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Features = _interopRequireDefault(require("self-service-api/constants/Features"));

var _marketingFreeFeature, _extends2, _extends3, _extends4, _salesFreeFeatureIds2, _extends5, _extends6, _extends7, _serviceFreeFeatureId, _extends8, _extends9, _extends10, _cmsFeatureIds2, _cmsProfessionalFeatu, _extends11, _crmFeatureIds2;

var _marketingFreeFeatureIds = (_marketingFreeFeature = {}, (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.ALL_CRM_FEATURES, {}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.FORMS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'limitedForms'
}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.EMAIL_MARKETING, {
  shortLimitKey: 'email2000SendsLimit',
  longLimitKey: 'emailMarketing'
}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.AD_MANAGEMENT, {
  shortLimitKey: 'allAdTypes1kSpendLimitSimpleAudiencesOnly',
  longLimitKey: 'adManagement'
}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.LIST_SEGMENTATION, {
  shortLimitKey: '5smartLists',
  longLimitKey: 'listSegmentation'
}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '1inbox',
  longLimitKey: 'conversationsInbox'
}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.TEAM_EMAIL, {}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.LIVE_CHAT, {}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'conversationalBots'
}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.MOBILE_OPTIMIZATION, {
  shortLimitKey: 'emailOnly',
  longLimitKey: 'mobileOptimization'
}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '3dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'marketingMessengerIntegration'
}), (0, _defineProperty2.default)(_marketingFreeFeature, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '10customProperties',
  longLimitKey: 'customProperties'
}), _marketingFreeFeature);

exports._marketingFreeFeatureIds = _marketingFreeFeatureIds;

var _marketingStarterFeatureIds = (0, _extends12.default)({}, _marketingFreeFeatureIds, (_extends2 = {}, (0, _defineProperty2.default)(_extends2, _Features.default.EMAIL_MARKETING, {
  shortLimitKey: 'email5xContactTierLimit',
  longLimitKey: 'emailMarketing'
}), (0, _defineProperty2.default)(_extends2, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '10dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends2, _Features.default.AD_MANAGEMENT, {
  shortLimitKey: 'allAdTypes1kSpendLimit2ContactLists',
  longLimitKey: 'adManagement'
}), (0, _defineProperty2.default)(_extends2, _Features.default.LIST_SEGMENTATION, {
  shortLimitKey: '25smartLists',
  longLimitKey: 'listSegmentation'
}), (0, _defineProperty2.default)(_extends2, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'marketingMessengerIntegration'
}), (0, _defineProperty2.default)(_extends2, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '1000customProperties',
  longLimitKey: 'customProperties'
}), (0, _defineProperty2.default)(_extends2, _Features.default.LANDING_PAGES, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'landingPagesMarketing'
}), (0, _defineProperty2.default)(_extends2, _Features.default.AD_RETARGETING, {
  shortLimitKey: 'allAdTypes1kSpendLimit',
  longLimitKey: 'adRetargeting'
}), (0, _defineProperty2.default)(_extends2, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: '5currencies',
  longLimitKey: 'multiCurrency'
}), (0, _defineProperty2.default)(_extends2, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '10dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends2, _Features.default.FORMS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'limitedForms'
}), _extends2));

exports._marketingStarterFeatureIds = _marketingStarterFeatureIds;

var _marketingProfessionalFeatureIds = (0, _extends12.default)({}, _marketingStarterFeatureIds, (_extends3 = {}, (0, _defineProperty2.default)(_extends3, _Features.default.FORMS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'limitedForms'
}), (0, _defineProperty2.default)(_extends3, _Features.default.AD_MANAGEMENT, {
  shortLimitKey: 'allAdTypes10kSpendLimit',
  longLimitKey: 'adManagement'
}), (0, _defineProperty2.default)(_extends3, _Features.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '100inboxes',
  longLimitKey: 'conversationsInbox'
}), (0, _defineProperty2.default)(_extends3, _Features.default.EMAIL_MARKETING, {
  shortLimitKey: 'email10xContactTierLimit',
  longLimitKey: 'emailMarketing'
}), (0, _defineProperty2.default)(_extends3, _Features.default.LIST_SEGMENTATION, {
  shortLimitKey: '1000smartLists',
  longLimitKey: 'listSegmentation'
}), (0, _defineProperty2.default)(_extends3, _Features.default.MOBILE_OPTIMIZATION, {}), (0, _defineProperty2.default)(_extends3, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '25dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends3, _Features.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'conversationalBots'
}), (0, _defineProperty2.default)(_extends3, _Features.default.PHONE_SUPPORT, {}), (0, _defineProperty2.default)(_extends3, _Features.default.CONTENT_CREATION_TOOLS, {}), (0, _defineProperty2.default)(_extends3, _Features.default.SEO_CONTENT_STRATEGY, {}), (0, _defineProperty2.default)(_extends3, _Features.default.CONTENT_STRATEGY, {}), (0, _defineProperty2.default)(_extends3, _Features.default.GOOGLE_SEARCH_CONSOLE_INTEGRATION, {}), (0, _defineProperty2.default)(_extends3, _Features.default.CALLS_TO_ACTION, {}), (0, _defineProperty2.default)(_extends3, _Features.default.LANDING_PAGES, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'landingPagesMarketing'
}), (0, _defineProperty2.default)(_extends3, _Features.default.SSL_CERTIFICATE, {}), (0, _defineProperty2.default)(_extends3, _Features.default.SOCIAL_MEDIA, {
  shortLimitKey: '50socialMediaAccounts',
  longLimitKey: 'socialMedia'
}), (0, _defineProperty2.default)(_extends3, _Features.default.SUBDOMAIN_AVAILABILITY, {
  shortLimitKey: 'unlimitedSubdomains',
  longLimitKey: 'subdomainAvailability'
}), (0, _defineProperty2.default)(_extends3, _Features.default.MARKETING_AUTOMATION, {
  shortLimitKey: '300workflows',
  longLimitKey: 'workflows'
}), (0, _defineProperty2.default)(_extends3, _Features.default.SALESFORCE_INTEGRATION, {
  shortLimitKey: 'salesforce',
  longLimitKey: 'salesforce'
}), (0, _defineProperty2.default)(_extends3, _Features.default.SMART_CONTENT, {}), (0, _defineProperty2.default)(_extends3, _Features.default.ATTRIBUTION_REPORTING, {
  shortLimitKey: '1attributionModel',
  longLimitKey: 'attributionReporting'
}), (0, _defineProperty2.default)(_extends3, _Features.default.AB_TESTING, {}), (0, _defineProperty2.default)(_extends3, _Features.default.VIDEO_HOSTING_MANAGEMENT, {
  shortLimitKey: '250Videos',
  longLimitKey: 'videoHostingManagement'
}), (0, _defineProperty2.default)(_extends3, _Features.default.TEAMS, {
  shortLimitKey: '10teams',
  longLimitKey: 'teamsProEnt'
}), (0, _defineProperty2.default)(_extends3, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: '30currencies',
  longLimitKey: 'multiCurrency'
}), (0, _defineProperty2.default)(_extends3, _Features.default.CUSTOM_REPORTS, {
  shortLimitKey: '100customReports',
  longLimitKey: 'customReports'
}), (0, _defineProperty2.default)(_extends3, _Features.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '5scoringPropertiesNotAdditive',
  longLimitKey: 'standardContactScoring'
}), (0, _defineProperty2.default)(_extends3, _Features.default.AD_RETARGETING, {
  shortLimitKey: 'allAdTypes10kSpendLimit',
  longLimitKey: 'adRetargeting'
}), (0, _defineProperty2.default)(_extends3, _Features.default.CAMPAIGN_REPORTING, {
  shortLimitKey: '1000campaigns',
  longLimitKey: 'campaignReporting'
}), (0, _defineProperty2.default)(_extends3, _Features.default.FILTERED_ANALYTICS_VIEW, {
  shortLimitKey: '25views',
  longLimitKey: 'filteredAnalyticsViews'
}), (0, _defineProperty2.default)(_extends3, _Features.default.CALCULATED_PROPERTIES, {
  shortLimitKey: '5properties',
  longLimitKey: 'calculatedProperties'
}), (0, _defineProperty2.default)(_extends3, _Features.default.WEBSITE_TRAFFIC_ANALYTICS, {}), (0, _defineProperty2.default)(_extends3, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'marketingMessengerIntegration'
}), (0, _defineProperty2.default)(_extends3, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '1000customProperties',
  longLimitKey: 'customProperties'
}), (0, _defineProperty2.default)(_extends3, _Features.default.RECORD_CUSTOMIZATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'limitedRecordCustomization'
}), (0, _defineProperty2.default)(_extends3, _Features.default.TARGET_ACCOUNTS_HOME, {}), (0, _defineProperty2.default)(_extends3, _Features.default.COMPANY_SCORING, {
  shortLimitKey: '5scoringPropertiesNotAdditive',
  longLimitKey: 'companyScoring'
}), _extends3));

exports._marketingProfessionalFeatureIds = _marketingProfessionalFeatureIds;

var _marketingEnterpriseFeatureIds = (0, _extends12.default)({}, _marketingProfessionalFeatureIds, (_extends4 = {}, (0, _defineProperty2.default)(_extends4, _Features.default.AD_MANAGEMENT, {
  shortLimitKey: 'allAdTypes30kSpendLimit',
  longLimitKey: 'adManagement'
}), (0, _defineProperty2.default)(_extends4, _Features.default.LIST_SEGMENTATION, {
  shortLimitKey: '1500smartLists',
  longLimitKey: 'listSegmentation'
}), (0, _defineProperty2.default)(_extends4, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '50dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends4, _Features.default.SOCIAL_MEDIA, {
  shortLimitKey: '300socialMediaAccounts',
  longLimitKey: 'socialMedia'
}), (0, _defineProperty2.default)(_extends4, _Features.default.MARKETING_AUTOMATION, {
  shortLimitKey: '1000workflows',
  longLimitKey: 'workflows'
}), (0, _defineProperty2.default)(_extends4, _Features.default.ATTRIBUTION_REPORTING, {
  shortLimitKey: '6attributionModels',
  longLimitKey: 'attributionReporting'
}), (0, _defineProperty2.default)(_extends4, _Features.default.TEAMS, {
  shortLimitKey: '300teamsPlusHierarchical',
  longLimitKey: 'teamsProEnt'
}), (0, _defineProperty2.default)(_extends4, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: '200currencies',
  longLimitKey: 'multiCurrency'
}), (0, _defineProperty2.default)(_extends4, _Features.default.CUSTOM_REPORTS, {
  shortLimitKey: '500customReports',
  longLimitKey: 'customReports'
}), (0, _defineProperty2.default)(_extends4, _Features.default.HIERARCHICAL_TEAMS, {
  shortLimitKey: '300teams',
  longLimitKey: 'hierarchicalTeams'
}), (0, _defineProperty2.default)(_extends4, _Features.default.CALCULATED_PROPERTIES, {
  shortLimitKey: '200properties',
  longLimitKey: 'calculatedProperties'
}), (0, _defineProperty2.default)(_extends4, _Features.default.ADAPTIVE_TESTING, {
  shortLimitKey: '5pageVariations',
  longLimitKey: 'adaptiveTesting'
}), (0, _defineProperty2.default)(_extends4, _Features.default.USER_ROLES, {}), (0, _defineProperty2.default)(_extends4, _Features.default.CUSTOM_EVENT_TRIGGERS_AND_REPORTING, {}), (0, _defineProperty2.default)(_extends4, _Features.default.EVENT_BASED_SEGMENTATION, {}), (0, _defineProperty2.default)(_extends4, _Features.default.PREDICTIVE_LEAD_SCORING, {}), (0, _defineProperty2.default)(_extends4, _Features.default.SINGLE_SIGN_ON, {}), (0, _defineProperty2.default)(_extends4, _Features.default.PARTITIONING, {}), (0, _defineProperty2.default)(_extends4, _Features.default.YOUTUBE_INTEGRATION, {}), (0, _defineProperty2.default)(_extends4, _Features.default.EVENTS_API, {}), (0, _defineProperty2.default)(_extends4, _Features.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '25scoringPropertiesNotAdditive',
  longLimitKey: 'standardContactScoring'
}), (0, _defineProperty2.default)(_extends4, _Features.default.SOCIAL_PERMISSIONS, {}), (0, _defineProperty2.default)(_extends4, _Features.default.FILTERED_ANALYTICS_VIEW, {
  shortLimitKey: '25views',
  longLimitKey: 'filteredAnalyticsViews'
}), (0, _defineProperty2.default)(_extends4, _Features.default.AD_RETARGETING, {
  shortLimitKey: 'allAdTypes30kSpendLimit',
  longLimitKey: 'adRetargeting'
}), (0, _defineProperty2.default)(_extends4, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'marketingMessengerIntegration'
}), (0, _defineProperty2.default)(_extends4, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '1000customProperties',
  longLimitKey: 'customProperties'
}), (0, _defineProperty2.default)(_extends4, _Features.default.MULTI_TOUCH_REVENUE_ATTRIBUTION, {}), (0, _defineProperty2.default)(_extends4, _Features.default.RECORD_CUSTOMIZATION, {}), (0, _defineProperty2.default)(_extends4, _Features.default.WEBHOOKS, {}), (0, _defineProperty2.default)(_extends4, _Features.default.COMPANY_SCORING, {
  shortLimitKey: '25scoringPropertiesNotAdditive',
  longLimitKey: 'companyScoring'
}), (0, _defineProperty2.default)(_extends4, _Features.default.FIELD_LEVEL_PERMISSIONS, {}), (0, _defineProperty2.default)(_extends4, _Features.default.LANDING_PAGES, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'landingPagesMarketing'
}), _extends4));

exports._marketingEnterpriseFeatureIds = _marketingEnterpriseFeatureIds;

var _salesFreeFeatureIds = (_salesFreeFeatureIds2 = {}, (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.ALL_CRM_FEATURES, {}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.LIVE_CHAT, {}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'conversationalBots'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.TEAM_EMAIL, {}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '1inbox',
  longLimitKey: 'conversationsInbox'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.CALLING, {
  shortLimitKey: '15minutes',
  longLimitKey: 'calling'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.EMAIL_SCHEDULING, {}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: '200notifications',
  longLimitKey: 'emailTrackingNotifications'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.TEMPLATES, {
  shortLimitKey: '5templates',
  longLimitKey: 'emailTemplates'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.SNIPPETS, {
  shortLimitKey: '5snippets',
  longLimitKey: 'snippets'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.DOCUMENTS, {
  shortLimitKey: '5documents',
  longLimitKey: 'documents'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.MEETINGS, {
  shortLimitKey: '1link',
  longLimitKey: 'meetings'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '3dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.DEAL_PIPELINE, {
  shortLimitKey: '1dealPipeline',
  longLimitKey: 'dealPipelines'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'salesAndServiceMessengerIntegration'
}), (0, _defineProperty2.default)(_salesFreeFeatureIds2, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '10customProperties',
  longLimitKey: 'customProperties'
}), _salesFreeFeatureIds2);

exports._salesFreeFeatureIds = _salesFreeFeatureIds;

var _salesStarterFeatureIds = (0, _extends12.default)({}, _salesFreeFeatureIds, (_extends5 = {}, (0, _defineProperty2.default)(_extends5, _Features.default.CALLING, {
  shortLimitKey: '8hours',
  longLimitKey: 'calling'
}), (0, _defineProperty2.default)(_extends5, _Features.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: 'unlimited',
  longLimitKey: 'emailTrackingNotifications'
}), (0, _defineProperty2.default)(_extends5, _Features.default.TEMPLATES, {
  shortLimitKey: '1000templates',
  longLimitKey: 'emailTemplates'
}), (0, _defineProperty2.default)(_extends5, _Features.default.SNIPPETS, {
  shortLimitKey: '1000snippets',
  longLimitKey: 'snippets'
}), (0, _defineProperty2.default)(_extends5, _Features.default.DOCUMENTS, {
  shortLimitKey: '1000documents',
  longLimitKey: 'documents'
}), (0, _defineProperty2.default)(_extends5, _Features.default.MEETINGS, {
  shortLimitKey: '1000links',
  longLimitKey: 'meetings'
}), (0, _defineProperty2.default)(_extends5, _Features.default.GOALS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'salesGoals'
}), (0, _defineProperty2.default)(_extends5, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: '5currencies',
  longLimitKey: 'multiCurrency'
}), (0, _defineProperty2.default)(_extends5, _Features.default.CALLING_SDK, {}), (0, _defineProperty2.default)(_extends5, _Features.default.EMAIL_SUPPORT, {}), (0, _defineProperty2.default)(_extends5, _Features.default.REP_PRODUCTIVITY_PERFORMANCE, {}), (0, _defineProperty2.default)(_extends5, _Features.default.CONVERSATION_ROUTING, {}), (0, _defineProperty2.default)(_extends5, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'salesAndServiceMessengerIntegration'
}), (0, _defineProperty2.default)(_extends5, _Features.default.SIMPLE_AUTOMATION, {}), (0, _defineProperty2.default)(_extends5, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '1000customProperties',
  longLimitKey: 'customProperties'
}), (0, _defineProperty2.default)(_extends5, _Features.default.QUOTES, {
  shortLimitKey: 'quotesNotTied',
  longLimitKey: '100quotesProEnt'
}), (0, _defineProperty2.default)(_extends5, _Features.default.DEAL_PIPELINE, {
  shortLimitKey: '2dealPipelines',
  longLimitKey: 'dealPipelines'
}), (0, _defineProperty2.default)(_extends5, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '10dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends5, _Features.default.STRIPE_INTEGRATION, {
  shortLimitKey: 'stripeAccountRequired',
  longLimitKey: 'requiresStripeAccount'
}), _extends5));

exports._salesStarterFeatureIds = _salesStarterFeatureIds;

var _salesProfessionalFeatureIds = (0, _extends12.default)({}, _salesStarterFeatureIds, (_extends6 = {}, (0, _defineProperty2.default)(_extends6, _Features.default.WORKFLOWS_EXTENSIONS, {}), (0, _defineProperty2.default)(_extends6, _Features.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '100inboxes',
  longLimitKey: 'conversationsInbox'
}), (0, _defineProperty2.default)(_extends6, _Features.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'conversationalBots'
}), (0, _defineProperty2.default)(_extends6, _Features.default.CALLING, {
  shortLimitKey: '16hours',
  longLimitKey: 'calling'
}), (0, _defineProperty2.default)(_extends6, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '25dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends6, _Features.default.DEAL_PIPELINE, {
  shortLimitKey: '15dealPipelines',
  longLimitKey: 'dealPipelines'
}), (0, _defineProperty2.default)(_extends6, _Features.default.SEQUENCES, {
  shortLimitKey: '1000sequences500emails',
  longLimitKey: 'emailSequences'
}), (0, _defineProperty2.default)(_extends6, _Features.default.ESIGN, {
  shortLimitKey: '10signatures',
  longLimitKey: 'eSignature'
}), (0, _defineProperty2.default)(_extends6, _Features.default.PHONE_SUPPORT, {}), (0, _defineProperty2.default)(_extends6, _Features.default.DEAL_STAGE_TASK_LEAD_ROTATION_AUTOMATION, {
  shortLimitKey: '300workflows',
  longLimitKey: 'workflows'
}), (0, _defineProperty2.default)(_extends6, _Features.default.QUOTES, {
  shortLimitKey: '100quotesPerDeal',
  longLimitKey: '100quotesProEnt'
}), (0, _defineProperty2.default)(_extends6, _Features.default.SMART_SEND_TIMES, {}), (0, _defineProperty2.default)(_extends6, _Features.default.SALESFORCE_INTEGRATION, {
  shortLimitKey: 'salesforce',
  longLimitKey: 'salesforce'
}), (0, _defineProperty2.default)(_extends6, _Features.default.STRIPE_INTEGRATION, {
  shortLimitKey: 'stripeAccountRequired',
  longLimitKey: 'requiresStripeAccount'
}), (0, _defineProperty2.default)(_extends6, _Features.default.REQUIRED_FIELDS, {}), (0, _defineProperty2.default)(_extends6, _Features.default.CUSTOM_REPORTS, {
  shortLimitKey: '100customReports',
  longLimitKey: 'customReports'
}), (0, _defineProperty2.default)(_extends6, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: '30currencies',
  longLimitKey: 'multiCurrency'
}), (0, _defineProperty2.default)(_extends6, _Features.default.VIDEO_CREATION, {}), (0, _defineProperty2.default)(_extends6, _Features.default.SEQUENCE_QUEUES, {}), (0, _defineProperty2.default)(_extends6, _Features.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '5scoringPropertiesNotAdditive',
  longLimitKey: 'standardContactScoring'
}), (0, _defineProperty2.default)(_extends6, _Features.default.TEAMS, {
  shortLimitKey: '10teams',
  longLimitKey: 'teamsProEnt'
}), (0, _defineProperty2.default)(_extends6, _Features.default.PRODUCTS, {}), (0, _defineProperty2.default)(_extends6, _Features.default.SLACK, {}), (0, _defineProperty2.default)(_extends6, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'salesAndServiceMessengerIntegration'
}), (0, _defineProperty2.default)(_extends6, _Features.default.CALCULATED_PROPERTIES, {
  shortLimitKey: '5properties',
  longLimitKey: 'calculatedProperties'
}), (0, _defineProperty2.default)(_extends6, _Features.default.RECORD_CUSTOMIZATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'limitedRecordCustomization'
}), (0, _defineProperty2.default)(_extends6, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '1000customProperties',
  longLimitKey: 'customProperties'
}), (0, _defineProperty2.default)(_extends6, _Features.default.TARGET_ACCOUNTS_HOME, {}), (0, _defineProperty2.default)(_extends6, _Features.default.COMPANY_SCORING, {
  shortLimitKey: '5scoringPropertiesNotAdditive',
  longLimitKey: 'companyScoring'
}), (0, _defineProperty2.default)(_extends6, _Features.default.ACCOUNT_OVERVIEW, {}), _extends6));

exports._salesProfessionalFeatureIds = _salesProfessionalFeatureIds;

var _salesEnterpriseFeatureIds = (0, _extends12.default)({}, _salesProfessionalFeatureIds, (_extends7 = {}, (0, _defineProperty2.default)(_extends7, _Features.default.CALLING, {
  shortLimitKey: '33hours',
  longLimitKey: 'calling'
}), (0, _defineProperty2.default)(_extends7, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '50dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends7, _Features.default.DEAL_PIPELINE, {
  shortLimitKey: '50dealPipelines',
  longLimitKey: 'dealPipelines'
}), (0, _defineProperty2.default)(_extends7, _Features.default.DEAL_STAGE_TASK_LEAD_ROTATION_AUTOMATION, {
  shortLimitKey: '1000workflows',
  longLimitKey: 'workflows'
}), (0, _defineProperty2.default)(_extends7, _Features.default.CUSTOM_REPORTS, {
  shortLimitKey: '500customReports',
  longLimitKey: 'customReports'
}), (0, _defineProperty2.default)(_extends7, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: '200currencies',
  longLimitKey: 'multiCurrency'
}), (0, _defineProperty2.default)(_extends7, _Features.default.HIERARCHICAL_TEAMS, {}), (0, _defineProperty2.default)(_extends7, _Features.default.PREDICTIVE_LEAD_SCORING, {}), (0, _defineProperty2.default)(_extends7, _Features.default.PLAYBOOKS, {
  shortLimitKey: '1000playbooks',
  longLimitKey: '1000playbooksEnt'
}), (0, _defineProperty2.default)(_extends7, _Features.default.ESIGN, {
  shortLimitKey: '30signatures',
  longLimitKey: 'eSignature'
}), (0, _defineProperty2.default)(_extends7, _Features.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '25scoringPropertiesNotAdditive',
  longLimitKey: 'standardContactScoring'
}), (0, _defineProperty2.default)(_extends7, _Features.default.TEAMS, {
  shortLimitKey: '300teamsPlusHierarchical',
  longLimitKey: 'teamsProEnt'
}), (0, _defineProperty2.default)(_extends7, _Features.default.SINGLE_SIGN_ON, {}), (0, _defineProperty2.default)(_extends7, _Features.default.WEBHOOKS, {}), (0, _defineProperty2.default)(_extends7, _Features.default.QUOTE_BASED_WORKFLOWS, {}), (0, _defineProperty2.default)(_extends7, _Features.default.GOALS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'salesGoals'
}), (0, _defineProperty2.default)(_extends7, _Features.default.RECURRING_REVENUE_TRACKING, {}), (0, _defineProperty2.default)(_extends7, _Features.default.CALCULATED_PROPERTIES, {
  shortLimitKey: '200properties',
  longLimitKey: 'calculatedProperties'
}), (0, _defineProperty2.default)(_extends7, _Features.default.CALL_TRANSCRIPTION, {
  shortLimitKey: 'englishOnly',
  longLimitKey: 'callTranscription'
}), (0, _defineProperty2.default)(_extends7, _Features.default.USER_ROLES, {}), (0, _defineProperty2.default)(_extends7, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'salesAndServiceMessengerIntegration'
}), (0, _defineProperty2.default)(_extends7, _Features.default.RECORD_CUSTOMIZATION, {}), (0, _defineProperty2.default)(_extends7, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '1000customProperties',
  longLimitKey: 'customProperties'
}), (0, _defineProperty2.default)(_extends7, _Features.default.STRIPE_INTEGRATION, {
  shortLimitKey: 'stripeAccountRequired',
  longLimitKey: 'requiresStripeAccount'
}), (0, _defineProperty2.default)(_extends7, _Features.default.SEQUENCES, {
  shortLimitKey: '1000sequences1000emails',
  longLimitKey: 'emailSequences'
}), (0, _defineProperty2.default)(_extends7, _Features.default.COMPANY_SCORING, {
  shortLimitKey: '25scoringPropertiesNotAdditive',
  longLimitKey: 'companyScoring'
}), (0, _defineProperty2.default)(_extends7, _Features.default.FIELD_LEVEL_PERMISSIONS, {}), _extends7));

exports._salesEnterpriseFeatureIds = _salesEnterpriseFeatureIds;

var _serviceFreeFeatureIds = (_serviceFreeFeatureId = {}, (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.ALL_CRM_FEATURES, {}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.TICKETING, {}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.LIVE_CHAT, {}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '1inbox',
  longLimitKey: 'conversationsInbox'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.CALLING, {
  shortLimitKey: '15minutes',
  longLimitKey: 'calling'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'conversationalBots'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.TEAM_EMAIL, {}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.SNIPPETS, {
  shortLimitKey: '5snippets',
  longLimitKey: 'snippets'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.TEMPLATES, {
  shortLimitKey: '5templates',
  longLimitKey: 'emailTemplates'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.MEETINGS, {
  shortLimitKey: '1link',
  longLimitKey: 'meetings'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.TICKETS_CLOSED_REPORTS, {
  shortLimitKey: 'standardServiceReport1Dashboard',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.REP_PRODUCTIVITY_REPORTS, {
  shortLimitKey: 'standardServiceReport1Dashboard',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.TIME_TO_CLOSE_REPORTS, {
  shortLimitKey: 'standardServiceReport1Dashboard',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '3dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: '200notifications',
  longLimitKey: 'emailTrackingNotifications'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.DOCUMENTS, {
  shortLimitKey: '5documents',
  longLimitKey: 'documents'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'salesAndServiceMessengerIntegration'
}), (0, _defineProperty2.default)(_serviceFreeFeatureId, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '10customProperties',
  longLimitKey: 'customProperties'
}), _serviceFreeFeatureId);

exports._serviceFreeFeatureIds = _serviceFreeFeatureIds;

var _serviceStarterFeatureIds = (0, _extends12.default)({}, _serviceFreeFeatureIds, (_extends8 = {}, (0, _defineProperty2.default)(_extends8, _Features.default.CALLING, {
  shortLimitKey: '8hours',
  longLimitKey: 'calling'
}), (0, _defineProperty2.default)(_extends8, _Features.default.SNIPPETS, {
  shortLimitKey: '1000snippets',
  longLimitKey: 'snippets'
}), (0, _defineProperty2.default)(_extends8, _Features.default.TEMPLATES, {
  shortLimitKey: '1000templates',
  longLimitKey: 'emailTemplates'
}), (0, _defineProperty2.default)(_extends8, _Features.default.MEETINGS, {
  shortLimitKey: '1000links',
  longLimitKey: 'meetings'
}), (0, _defineProperty2.default)(_extends8, _Features.default.TICKETS_CLOSED_REPORTS, {
  shortLimitKey: 'standardServiceAndProductivityReport1Dashboard',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_extends8, _Features.default.REP_PRODUCTIVITY_REPORTS, {
  shortLimitKey: 'standardServiceAndProductivityReport1Dashboard',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_extends8, _Features.default.TIME_TO_CLOSE_REPORTS, {
  shortLimitKey: 'standardServiceAndProductivityReport1Dashboard',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_extends8, _Features.default.EMAIL_SCHEDULING, {}), (0, _defineProperty2.default)(_extends8, _Features.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: 'unlimited',
  longLimitKey: 'emailTrackingNotifications'
}), (0, _defineProperty2.default)(_extends8, _Features.default.DOCUMENTS, {
  shortLimitKey: '1000documents',
  longLimitKey: 'documents'
}), (0, _defineProperty2.default)(_extends8, _Features.default.CALLING_SDK, {}), (0, _defineProperty2.default)(_extends8, _Features.default.CONVERSATION_ROUTING, {}), (0, _defineProperty2.default)(_extends8, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'salesAndServiceMessengerIntegration'
}), (0, _defineProperty2.default)(_extends8, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '1000customProperties',
  longLimitKey: 'customProperties'
}), (0, _defineProperty2.default)(_extends8, _Features.default.MULTIPLE_TICKET_PIPELINES, {
  shortLimitKey: '2ticketPipelines',
  longLimitKey: 'ticketPipelines'
}), (0, _defineProperty2.default)(_extends8, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: '5currencies',
  longLimitKey: 'multiCurrency'
}), (0, _defineProperty2.default)(_extends8, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '10dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends8, _Features.default.SIMPLE_AUTOMATION, {}), _extends8));

exports._serviceStarterFeatureIds = _serviceStarterFeatureIds;

var _serviceProfessionalFeatureIds = (0, _extends12.default)({}, _serviceStarterFeatureIds, (_extends9 = {}, (0, _defineProperty2.default)(_extends9, _Features.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'conversationalBots'
}), (0, _defineProperty2.default)(_extends9, _Features.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '100inboxes',
  longLimitKey: 'conversationsInbox'
}), (0, _defineProperty2.default)(_extends9, _Features.default.CALLING, {
  shortLimitKey: '16hours',
  longLimitKey: 'calling'
}), (0, _defineProperty2.default)(_extends9, _Features.default.SEQUENCES, {
  shortLimitKey: '1000sequences500emails',
  longLimitKey: 'emailSequences'
}), (0, _defineProperty2.default)(_extends9, _Features.default.TICKETS_CLOSED_REPORTS, {
  shortLimitKey: 'standardServiceDashboard1CustomDashboard',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_extends9, _Features.default.REP_PRODUCTIVITY_REPORTS, {
  shortLimitKey: 'standardServiceDashboard1CustomDashboard',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_extends9, _Features.default.TIME_TO_CLOSE_REPORTS, {
  shortLimitKey: 'standardServiceDashboard1CustomDashboard',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_extends9, _Features.default.MULTIPLE_TICKET_PIPELINES, {
  shortLimitKey: '15ticketPipelines',
  longLimitKey: 'ticketPipelines'
}), (0, _defineProperty2.default)(_extends9, _Features.default.KNOWLEDGE_BASE, {}), (0, _defineProperty2.default)(_extends9, _Features.default.VIDEO_CREATION_AND_HOSTING, {}), (0, _defineProperty2.default)(_extends9, _Features.default.NPS_SURVEYS, {}), (0, _defineProperty2.default)(_extends9, _Features.default.CUSTOMER_EXPERIENCE_SURVEYS, {}), (0, _defineProperty2.default)(_extends9, _Features.default.CUSTOMER_SUPPORT_SURVEYS, {}), (0, _defineProperty2.default)(_extends9, _Features.default.INSIGHTS_DASHBOARD, {}), (0, _defineProperty2.default)(_extends9, _Features.default.CUSTOM_REPORTS, {
  shortLimitKey: '100customReports',
  longLimitKey: 'customReports'
}), (0, _defineProperty2.default)(_extends9, _Features.default.TICKET_STATUS_ROUTING_TASK_AUTOMATION, {
  shortLimitKey: '300workflows',
  longLimitKey: 'workflows'
}), (0, _defineProperty2.default)(_extends9, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '25dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends9, _Features.default.TEAMS, {
  shortLimitKey: '10teams',
  longLimitKey: 'teamsProEnt'
}), (0, _defineProperty2.default)(_extends9, _Features.default.SALESFORCE_INTEGRATION, {
  shortLimitKey: 'salesforce',
  longLimitKey: 'salesforce'
}), (0, _defineProperty2.default)(_extends9, _Features.default.PHONE_SUPPORT, {}), (0, _defineProperty2.default)(_extends9, _Features.default.CUSTOMER_FEEDBACK, {}), (0, _defineProperty2.default)(_extends9, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: '30currencies',
  longLimitKey: 'multiCurrency'
}), (0, _defineProperty2.default)(_extends9, _Features.default.SEQUENCE_QUEUES, {}), (0, _defineProperty2.default)(_extends9, _Features.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '5scoringPropertiesNotAdditive',
  longLimitKey: 'standardContactScoring'
}), (0, _defineProperty2.default)(_extends9, _Features.default.CUSTOMER_SERVICE_AUTOMATION, {
  shortLimitKey: '300workflows',
  longLimitKey: 'workflows'
}), (0, _defineProperty2.default)(_extends9, _Features.default.SLACK, {}), (0, _defineProperty2.default)(_extends9, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'salesAndServiceMessengerIntegration'
}), (0, _defineProperty2.default)(_extends9, _Features.default.CALCULATED_PROPERTIES, {
  shortLimitKey: '5properties',
  longLimitKey: 'calculatedProperties'
}), (0, _defineProperty2.default)(_extends9, _Features.default.RECORD_CUSTOMIZATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'limitedRecordCustomization'
}), (0, _defineProperty2.default)(_extends9, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '1000customProperties',
  longLimitKey: 'customProperties'
}), (0, _defineProperty2.default)(_extends9, _Features.default.VIDEO_HOSTING_MANAGEMENT, {
  shortLimitKey: '250Videos',
  longLimitKey: 'videoHostingManagement'
}), _extends9));

exports._serviceProfessionalFeatureIds = _serviceProfessionalFeatureIds;

var _serviceEnterpriseFeatureIds = (0, _extends12.default)({}, _serviceProfessionalFeatureIds, (_extends10 = {}, (0, _defineProperty2.default)(_extends10, _Features.default.CALLING, {
  shortLimitKey: '33hours',
  longLimitKey: 'calling'
}), (0, _defineProperty2.default)(_extends10, _Features.default.TICKETS_CLOSED_REPORTS, {
  shortLimitKey: 'standardServiceDashboard25CustomDashboards',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_extends10, _Features.default.REP_PRODUCTIVITY_REPORTS, {
  shortLimitKey: 'standardServiceDashboard25CustomDashboards',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_extends10, _Features.default.TIME_TO_CLOSE_REPORTS, {
  shortLimitKey: 'standardServiceDashboard25CustomDashboards',
  longLimitKey: 'serviceReports'
}), (0, _defineProperty2.default)(_extends10, _Features.default.SEQUENCES, {
  shortLimitKey: '1000sequences1000emails',
  longLimitKey: 'emailSequences'
}), (0, _defineProperty2.default)(_extends10, _Features.default.MULTIPLE_TICKET_PIPELINES, {
  shortLimitKey: '50ticketPipelines',
  longLimitKey: 'ticketPipelines'
}), (0, _defineProperty2.default)(_extends10, _Features.default.CUSTOM_REPORTS, {
  shortLimitKey: '500customReports',
  longLimitKey: 'customReports'
}), (0, _defineProperty2.default)(_extends10, _Features.default.PLAYBOOKS, {
  shortLimitKey: '1000playbooks',
  longLimitKey: '1000playbooksEnt'
}), (0, _defineProperty2.default)(_extends10, _Features.default.CALL_TRANSCRIPTION, {
  shortLimitKey: 'englishOnly',
  longLimitKey: 'callTranscription'
}), (0, _defineProperty2.default)(_extends10, _Features.default.HIERARCHICAL_TEAMS, {}), (0, _defineProperty2.default)(_extends10, _Features.default.USER_ROLES, {}), (0, _defineProperty2.default)(_extends10, _Features.default.SINGLE_SIGN_ON, {}), (0, _defineProperty2.default)(_extends10, _Features.default.WEBHOOKS, {}), (0, _defineProperty2.default)(_extends10, _Features.default.TICKET_STATUS_ROUTING_TASK_AUTOMATION, {
  shortLimitKey: '1000workflows',
  longLimitKey: 'workflows'
}), (0, _defineProperty2.default)(_extends10, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '50dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends10, _Features.default.TEAMS, {
  shortLimitKey: '300teamsPlusHierarchical',
  longLimitKey: 'teamsProEnt'
}), (0, _defineProperty2.default)(_extends10, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: '200currencies',
  longLimitKey: 'multiCurrency'
}), (0, _defineProperty2.default)(_extends10, _Features.default.CALCULATED_PROPERTIES, {
  shortLimitKey: '200properties',
  longLimitKey: 'calculatedProperties'
}), (0, _defineProperty2.default)(_extends10, _Features.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '25scoringPropertiesNotAdditive',
  longLimitKey: 'standardContactScoring'
}), (0, _defineProperty2.default)(_extends10, _Features.default.CUSTOMER_SERVICE_AUTOMATION, {
  shortLimitKey: '1000workflows',
  longLimitKey: 'workflows'
}), (0, _defineProperty2.default)(_extends10, _Features.default.GOALS, {}), (0, _defineProperty2.default)(_extends10, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'salesAndServiceMessengerIntegration'
}), (0, _defineProperty2.default)(_extends10, _Features.default.RECORD_CUSTOMIZATION, {}), (0, _defineProperty2.default)(_extends10, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '1000customProperties',
  longLimitKey: 'customProperties'
}), (0, _defineProperty2.default)(_extends10, _Features.default.FIELD_LEVEL_PERMISSIONS, {}), _extends10));

exports._serviceEnterpriseFeatureIds = _serviceEnterpriseFeatureIds;

var _cmsFeatureIds = (_cmsFeatureIds2 = {}, (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.ALL_CRM_FEATURES, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.FORMS, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.FORM_FOLLOWUP_EMAILS, {
  shortLimitKey: '3emailsPerForm',
  longLimitKey: '3emailsPerForm'
}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.PHONE_SUPPORT, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.AD_MANAGEMENT, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.LIST_SEGMENTATION, {
  shortLimitKey: '1000smartLists',
  longLimitKey: 'cmsListSegmentation'
}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.MOBILE_OPTIMIZATION, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.CONTENT_CREATION_TOOLS, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.CALLS_TO_ACTION, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.LANDING_PAGES, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.SSL_CERTIFICATE, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.SMART_CONTENT, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.HUB_DB_DYNAMIC_CONTENT, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.WEBSITE_PAGES, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.DESIGN_MANAGER, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.STAGING_ENVIRONMENT, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.TEMPLATE_AND_MODULE_MARKETPLACE, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.WEBSITE_ANALYTICS, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.SEO_CONTENT_STRATEGY, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.GOOGLE_SEARCH_CONSOLE_INTEGRATION, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.CUSTOM_DOMAINS, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.UPTIME, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.CONTENT_DELIVERY_NETWORK, {}), (0, _defineProperty2.default)(_cmsFeatureIds2, _Features.default.SECURITY_MONITORING_THREAT_DETECTION, {}), _cmsFeatureIds2);

exports._cmsFeatureIds = _cmsFeatureIds;

var _cmsProfessionalFeatureIds = (_cmsProfessionalFeatu = {}, (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.ALL_CRM_FEATURES, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.FORMS, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.DRAG_AND_DROP_EDITOR, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.PHONE_SUPPORT, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.LIST_SEGMENTATION, {
  shortLimitKey: '5smartListsPlain',
  longLimitKey: 'cmsHubListSegmentation'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.MOBILE_OPTIMIZATION, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.BLOG, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CALLS_TO_ACTION, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.LANDING_PAGES, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'landingPagesCms'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.SSL_CERTIFICATE, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.SMART_CONTENT_AND_REPORTING, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.HUB_DB_DYNAMIC_CONTENT, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.RECORD_CUSTOMIZATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'limitedRecordCustomization'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '5scoringPropertiesNotAdditive',
  longLimitKey: 'standardContactScoring'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: 'upTo30currencies',
  longLimitKey: 'multipleCurrencies'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.SALESFORCE_INTEGRATION, {
  shortLimitKey: 'cmsSalesforce',
  longLimitKey: 'cmsSalesforce'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CALCULATED_PROPERTIES, {
  shortLimitKey: '5properties',
  longLimitKey: 'calculatedProperties'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.WEBSITE_PAGES, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.DESIGN_MANAGER, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CONTENT_STAGING, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.TEMPLATE_AND_MODULE_MARKETPLACE, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CONTENT_ANALYTICS_VIEW, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.GOOGLE_SEARCH_CONSOLE_INTEGRATION, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CUSTOM_DOMAINS, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.SUBDOMAIN_AND_COUNTRY_CODE_TLD, {
  shortLimitKey: 'subdomainTLD1Root',
  longLimitKey: 'subdomainTLD'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.UPTIME, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CDN, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.AD_MANAGEMENT, {
  shortLimitKey: 'adManagement',
  longLimitKey: 'cmsHubAdManagement'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.FORM_FOLLOWUP_EMAILS, {
  shortLimitKey: '3emailsPerForm',
  longLimitKey: 'cmsHub3emailsPerForm'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.BUILT_IN_AMP_SUPPORT, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.WEBSITE_THEMES, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.LOCAL_WEBSITE_DEVELOPMENT, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.VIDEO_HOSTING_MANAGEMENT, {
  shortLimitKey: '250Videos',
  longLimitKey: 'videoHostingManagement'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.ADVANCED_MENUS, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.APP_AND_ASSET_MARKETPLACE, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.PASSWORD_PROTECTED_PAGES, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.MULTI_LANGUAGE_CREATION_TESTING, {
  shortLimitKey: '2pageAbTesting',
  longLimitKey: 'contentCreationTesting'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.LIVE_CHAT, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'cmsHubConversationalBots'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '100inboxes',
  longLimitKey: 'cmsHubConversationsInbox'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'messengerIntegration'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.EMAIL_MARKETING, {
  shortLimitKey: 'email2000Sends',
  longLimitKey: 'cmsEmailMarketing'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.SEO_RECOMMEND_OPTIMIZE, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CONTENT_STRATEGY, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.AB_TESTING, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CUSTOM_REPORTS, {
  shortLimitKey: '100customReports',
  longLimitKey: 'customReports'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.CONTACT_ATTRIBUTION_REPORT_BUILDER, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '25dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.SITE_EXPORT, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.BLOG_IMPORT, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.URL_MAPPINGS, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.WEBSITE_TRAFFIC_ANALYTICS, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.USER_ROLES, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.TWENTY_FOUR_SEVEN_SECURITY_MONITORING, {}), (0, _defineProperty2.default)(_cmsProfessionalFeatu, _Features.default.TEAMS, {
  shortLimitKey: '10teams',
  longLimitKey: 'teamsProEnt'
}), _cmsProfessionalFeatu);

exports._cmsProfessionalFeatureIds = _cmsProfessionalFeatureIds;

var _cmsEnterpriseFeatureIds = (0, _extends12.default)({}, _cmsProfessionalFeatureIds, (_extends11 = {}, (0, _defineProperty2.default)(_extends11, _Features.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '25scoringPropertiesNotAdditive',
  longLimitKey: 'standardContactScoring'
}), (0, _defineProperty2.default)(_extends11, _Features.default.MULTI_CURRENCY, {
  shortLimitKey: 'upTo200currencies',
  longLimitKey: 'multipleCurrencies'
}), (0, _defineProperty2.default)(_extends11, _Features.default.CALCULATED_PROPERTIES, {
  shortLimitKey: '200properties',
  longLimitKey: 'calculatedProperties'
}), (0, _defineProperty2.default)(_extends11, _Features.default.MULTI_LANGUAGE_CREATION_TESTING, {
  shortLimitKey: '2pageAbAdaptiveTesting',
  longLimitKey: 'contentCreationTesting'
}), (0, _defineProperty2.default)(_extends11, _Features.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'cmsHubConversationalBots'
}), (0, _defineProperty2.default)(_extends11, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'messengerIntegration'
}), (0, _defineProperty2.default)(_extends11, _Features.default.CUSTOM_REPORTS, {
  shortLimitKey: '500customReports',
  longLimitKey: 'customReports'
}), (0, _defineProperty2.default)(_extends11, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '50dashboards',
  longLimitKey: 'reportingDashboards'
}), (0, _defineProperty2.default)(_extends11, _Features.default.ADAPTIVE_TESTING, {
  shortLimitKey: 'test5Variations',
  longLimitKey: 'adaptiveTesting'
}), (0, _defineProperty2.default)(_extends11, _Features.default.RECORD_CUSTOMIZATION, {}), (0, _defineProperty2.default)(_extends11, _Features.default.MEMBERSHIPS, {}), (0, _defineProperty2.default)(_extends11, _Features.default.TWO_BRAND_DOMAINS, {}), (0, _defineProperty2.default)(_extends11, _Features.default.CODE_ALERTS, {}), (0, _defineProperty2.default)(_extends11, _Features.default.PARTITIONING, {}), (0, _defineProperty2.default)(_extends11, _Features.default.REVERSE_PROXY_SUPPORT, {}), (0, _defineProperty2.default)(_extends11, _Features.default.CUSTOM_CDN_CONFIGURATION, {}), (0, _defineProperty2.default)(_extends11, _Features.default.SITE_PERFORMANCE_MONITORING, {}), (0, _defineProperty2.default)(_extends11, _Features.default.ACTIVITY_LOGGING, {}), (0, _defineProperty2.default)(_extends11, _Features.default.SINGLE_SIGN_ON, {}), (0, _defineProperty2.default)(_extends11, _Features.default.HIERARCHICAL_TEAMS, {
  shortLimitKey: 'upTo300Teams',
  longLimitKey: 'cmsHubHierarchicalTeams'
}), (0, _defineProperty2.default)(_extends11, _Features.default.LANDING_PAGES, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'landingPagesCms'
}), (0, _defineProperty2.default)(_extends11, _Features.default.SERVERLESS_FUNCTIONS, {}), (0, _defineProperty2.default)(_extends11, _Features.default.FIELD_LEVEL_PERMISSIONS, {}), (0, _defineProperty2.default)(_extends11, _Features.default.TEAMS, {
  shortLimitKey: '300teamsPlusHierarchical',
  longLimitKey: 'teamsProEnt'
}), _extends11));

exports._cmsEnterpriseFeatureIds = _cmsEnterpriseFeatureIds;

var _crmFeatureIds = (_crmFeatureIds2 = {}, (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.CONTACT_MANAGEMENT, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.CONTACT_WEBSITE_ACTIVITY, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.COMPANIES, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.DEALS, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.TASKS_AND_ACTIVITIES, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.COMPANY_INSIGHTS, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.GMAIL_AND_OUTLOOK_INTEGRATION, {
  shortLimitKey: 'gmailOutlook',
  longLimitKey: 'gmailOutlook'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.HUBSPOT_CONNECT_INTEGRATIONS, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.CUSTOM_SUPPORT_FORM_FIELDS, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.PROSPECTS, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.TICKETING, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.FORMS, {}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.AD_MANAGEMENT, {
  shortLimitKey: 'allAdTypes1kSpendLimitSimpleAudiencesOnly',
  longLimitKey: 'crmAdManagement'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '1inbox',
  longLimitKey: 'crmConversationsInbox'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '3dashboards',
  longLimitKey: 'crmReportingDashboards'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: '200notifications',
  longLimitKey: 'crmEmailTrackingNotifications'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.TEMPLATES, {
  shortLimitKey: '5templates',
  longLimitKey: 'crmEmailTemplates'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.SNIPPETS, {
  shortLimitKey: '5snippets',
  longLimitKey: 'crmSnippets'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.DOCUMENTS, {
  shortLimitKey: '5documents',
  longLimitKey: 'crmDocuments'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.CALLING, {
  shortLimitKey: '15minutes',
  longLimitKey: 'crmCalling'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.MEETINGS, {
  shortLimitKey: '1meetingLink',
  longLimitKey: 'crmMeetings'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.MESSENGER_INTEGRATION, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'marketingMessengerIntegration'
}), (0, _defineProperty2.default)(_crmFeatureIds2, _Features.default.CUSTOM_PROPERTIES, {
  shortLimitKey: '10customProperties',
  longLimitKey: 'customProperties'
}), _crmFeatureIds2);

exports._crmFeatureIds = _crmFeatureIds;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/_MerchandiseFeatures.js
// module id = 403
// module chunks = 5 6 7